module.exports = __webpack_public_path__ + "img/artboard12.93379231.png";